import { render, staticRenderFns } from "./RiskInformationQuotator.vue?vue&type=template&id=07f85f04&scoped=true&"
import script from "./RiskInformationQuotator.vue?vue&type=script&lang=js&"
export * from "./RiskInformationQuotator.vue?vue&type=script&lang=js&"
import style0 from "./RiskInformationQuotator.vue?vue&type=style&index=0&id=07f85f04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f85f04",
  null
  
)

export default component.exports